(function($) {
    var numSlick = 0;
    var $sliderFeatures = $('.slider-videos');

    // Slider with CTA cards
    $sliderFeatures.each(function() {
        numSlick++;

        $(this).addClass('slider-videos' + numSlick).slick({
            accessibility: false,
            arrows: true,
            dots: false,
            infinite: false,
            slide: '.slider-item',
            slidesToScroll: 1,
            slidesToShow: 1.2,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1.2,
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1.2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1.2,
                    }
                }]
        });
    })
        .on('setPosition', function (event, slick) {
            $(slick.$slides).height('auto').css('height', $(slick.$slideTrack).height() + 'px');
        });

})(jQuery);
function updateSlickNextPositionAlt() {
    $('.slider-videos').each(function() {
        var $slider = $(this);
        var $slickList = $slider.find('.slick-list');
        var $nextButton = $slider.find('.slick-next');

        if ($slickList.length && $nextButton.length) {
            // Calculate based on the visible area, not the moving slides
            var visibleWidth = $slickList.width();
            var slidesToShow = 1.2; // Your slidesToShow value
            var singleSlideWidth = visibleWidth / slidesToShow;

            // Position 15px to the right of the first full slide
            var buttonPosition = singleSlideWidth + 75;

            // Different positioning based on screen size
            if ($(window).width() <= 599) {
                $nextButton.css({
                    'position': 'absolute',
                    'left': buttonPosition + 'px',
                    'right': 'auto',
                    'top': 'initial',
                    'bottom': '0px',
                    'transform': 'none',
                    'z-index': '10'
                });
            } else {
                $nextButton.css({
                    'position': 'absolute',
                    'left': buttonPosition + 'px',
                    'right': 'auto',
                    'top': '50%',
                    'bottom': 'auto',
                    'transform': 'translateY(-50%)',
                    'z-index': '10'
                });
            }
        }
    });
}

function updateSlickPrevPosition() {
    $('.slider-videos').each(function() {
        var $slider = $(this);
        var $slickList = $slider.find('.slick-list');
        var $prevButton = $slider.find('.slick-prev');

        if ($slickList.length && $prevButton.length) {
            // Position 70px to the left (negative value for left side)
            var buttonPosition = 70;

            // Different positioning based on screen size
            if ($(window).width() <= 599) {
                $prevButton.css({
                    'position': 'absolute',
                    'left': buttonPosition + 'px',
                    'right': 'auto',
                    'top': 'initial',
                    'bottom': '0px',
                    'transform': 'none',
                    'z-index': '10'
                });
            } else {

            }
        }
    });
}

// Call both functions
$(document).ready(function() {
    setTimeout(function() {
        updateSlickNextPositionAlt();
        updateSlickPrevPosition();
    }, 100);
});

$(window).on('resize', function() {
    updateSlickNextPositionAlt();
    updateSlickPrevPosition();
});